import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export function NewsletterBox({ compact = false }) {
  const [email, setEmail] = useState("");
  const [segment, setSegment] = useState("entrambi");
  const [consent, setConsent] = useState(false);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Devi accettare la Privacy Policy");
    setLoading(true);
    try {
      await api.post("/public/newsletter", { email, segment, consent_privacy: consent });
      setDone(true);
      toast.success("Iscrizione completata!");
    } catch (err) { toast.error(errorMessage(err)); } finally { setLoading(false); }
  };

  if (done) return (
    <div className="surface p-6 flex items-center gap-3 text-emerald-500" data-testid="newsletter-success">
      <Check /> <span className="font-medium">Sei dentro! Controlla la posta per la conferma.</span>
    </div>
  );

  return (
    <form onSubmit={submit} className={`surface ${compact ? "p-5" : "p-7"} relative overflow-hidden`} data-testid="newsletter-form">
      <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-emerald-500/10 blur-2xl" />
      <p className="label-mono mb-2">Newsletter settimanale</p>
      <h3 className="font-display text-xl font-semibold mb-1">Risparmia sulle spese veterinarie</h3>
      <p className="text-sm text-muted-foreground mb-4">Ogni settimana: i migliori articoli, promo polizze e consigli pratici. Zero spam.</p>
      <div className="flex gap-2 mb-3 text-sm">
        {["cane", "gatto", "entrambi"].map((s) => (
          <button type="button" key={s} onClick={() => setSegment(s)} data-testid={`newsletter-segment-${s}`}
            className={`px-3 py-1.5 rounded-full border capitalize transition-colors ${segment === s ? "border-emerald-500 bg-emerald-500/10 text-emerald-500" : "border-border hover:bg-muted"}`}>{s}</button>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input type="email" required className="input !pl-9" placeholder="la-tua@email.it" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-email-input" />
        </div>
        <button className="btn-primary !py-2.5 text-sm" disabled={loading} data-testid="newsletter-submit-btn">{loading ? "..." : "Iscrivimi"}</button>
      </div>
      <label className="flex items-start gap-2 mt-3 text-xs text-muted-foreground cursor-pointer">
        <input type="checkbox" className="mt-0.5 accent-emerald-500" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="newsletter-consent-checkbox" />
        <span>Ho letto la <Link to="/privacy" className="underline">Privacy Policy</Link> e acconsento a ricevere la newsletter.</span>
      </label>
    </form>
  );
}
